import _ from "lodash";
import React, { useState } from "react";
import { Form } from "react-final-form";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { DetailedErrorAlert } from "../../../components/DetailedErrorAlert";
import { adminApi as api, extractErrorMessage } from "../../../util/api";
import { parseCurrency } from "../../../util/formatters";
import { snakifyKeys } from "../../../util/helpers";
import { NonCoveredPricingForm } from "./NonCoveredPricingForm";

export const CreateNonCoveredPricingModal = ({ labId, onCreate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen(!open);

  const handleCreate = async (values) => {
    const newValues = _.cloneDeep(values);

    setError(null);
    try {
      newValues.labId = labId;

      if (newValues.priceCents) {
        newValues.priceCents = parseCurrency(newValues.priceCents) * 100;
      }

      const res = await api.post("/admin/non_covered_pricings", { non_covered_pricing: snakifyKeys(newValues) });

      if (onCreate) {
        onCreate(res.data.resource);
      }

      setOpen(false);
    } catch (err) {
      setError(extractErrorMessage(err));
    }
  };

  return (
    <>
      <Button onClick={toggleModal} {...rest}>
        Add Non-Covered Price
      </Button>

      <Modal isOpen={open} toggle={toggleModal} size="lg">
        <ModalHeader toggle={toggleModal}>Add Non-Covered Price</ModalHeader>

        <ModalBody>
          <DetailedErrorAlert error={error} />

          <Form onSubmit={handleCreate}>{(props) => <NonCoveredPricingForm {...props} />}</Form>
        </ModalBody>
      </Modal>
    </>
  );
};
